import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { ReportService } from 'src/app/_service/report.service';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
declare var $: any;


@Component({
  selector: 'app-emi-report',
  templateUrl: './emi-report.component.html',
  styleUrls: ['./emi-report.component.css']
})
export class EmiReportComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; ipdList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circle = '';
  search: string; currentUserId: any; circles_copy = []; status = ''; vendor = ''; feedBackUser = []; feedBackUser_copy = []; feedBack_User = '';
  booleanValue: any = false; PageType = 0; start_date: string = ''; end_date: string = ''; ipd_start_date: string = ''; ipd_end_date: string = '';
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;
  @ViewChild('scanDateRangeStart', { static: false }) scanDateRangeStart: ElementRef;
  @ViewChild('scanDateRangeEnd', { static: false }) scanDateRangeEnd: ElementRef;

  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private reportapi: ReportService) { }

  ngOnInit(): void {
    this.getcircle();
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    }
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  ngAfterViewInit() {
    this.loadEmiList(0, this.perpage, this.PageType);
  }

  tabClick(event) {
    if (event.index == 0) {
      this.PageType = 0;
      this.loadEmiList(0, this.perpage, this.PageType);
    } else {
      this.PageType = 1;
      this.loadEmiList(0, this.perpage, this.PageType);

    }
  }

  loadEmiList(pageIndex, perpage, type) {
    this.ipdList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&vendor=' + this.vendor + '&date_range=' + this.start_date + '-' + this.end_date + '&ipd_date_range=' + this.ipd_start_date + '-' + this.ipd_end_date;
    this.loading = true; this.loaded = false;
    this.reportapi.getIpdScanBookEmiReport(this.paginator.pageIndex, perpage, qString, type).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.ipdList = data.data;
      } else {
        this.ipdList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadEmiList(event.pageIndex, event.pageSize, this.PageType);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadEmiList(event.pageIndex, event.pageSize, this.PageType);
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  resetIpdEmiFilter() {
    this.clearDate();
    this.search = ''; this.circle = ''; this.vendor = '';
    this.loadEmiList(0, 25, 0);
  }

  resetScanEmiFilter() {
    this.clearScanDate();
    this.search = ''; this.circle = '';
    this.loadEmiList(0, 25, 1);
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }
  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  scanDateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }
  clearScanDate() {
    this.scanDateRangeStart.nativeElement.value = "";
    this.scanDateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  ipdFeedbackDateRangeChange(date1, date2) {
    if (date2.value) {
      this.ipd_start_date = date1.value;
      this.ipd_end_date = date2.value;
    }
  }

  //------------------Export Ipd EMI List ---------------------//
  exportIpdList() {
    if (this.ipdList.length > 0) {
      let data = [];
      let titles = ['Patient Name', 'Mobile', 'SURGERY DATE', 'Circle', 'Treatment', 'Doctor', 'Hospital', 'BILLED AMOUNT', 'VENDOR NAME'];

      data.push(titles);
      for (let key in this.ipdList) {

        var ipd_surgery_date = '';
        if (this.ipdList[key].ipd_surgery_date) {
          ipd_surgery_date = formatDate(this.ipdList[key].ipd_surgery_date * 1000, 'dd MMM, yyyy', 'en-US');
        }

        let extData = [this.ipdList[key].patient, this.ipdList[key].phone, ipd_surgery_date, this.ipdList[key].circle_name, this.ipdList[key].treatment_name, this.ipdList[key].doctor_name, this.ipdList[key].hospital_name, this.ipdList[key].billed_amt, this.ipdList[key].emi_vendor_name];

        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'IpdEmiList_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Data found!');
    }
  }

  //------------------Export Scan EMI List ---------------------//
  exportScanBookList() {
    if (this.ipdList.length > 0) {
      let data = [];
      let titles = ['Patient Name', 'Mobile', 'Scan Done Date', 'Circle', 'Treatment', 'Doctor', 'Hospital', 'BILLED AMOUNT', 'RECEIVED AMOUNT'];

      data.push(titles);
      for (let key in this.ipdList) {

        var scan_done_date = '';
        if (this.ipdList[key].scan_done_date) {
          scan_done_date = formatDate(this.ipdList[key].scan_done_date * 1000, 'dd MMM, yyyy', 'en-US');
        }

        let extData = [this.ipdList[key].patient, this.ipdList[key].phone, scan_done_date, this.ipdList[key].circle_name, this.ipdList[key].treatment_name, this.ipdList[key].doctor_name, this.ipdList[key].hospital_name, this.ipdList[key].billed_amt, this.ipdList[key].received_amt];

        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'ScanBookEmiList_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Data found!');
    }
  }



}
